<template>
  <div>
    <vs-popup :title="$t('CreateNewOperator')" :active.sync="showModal">
      <form class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-2">
          <vs-input
            class="inputx"
            v-model="model.firstName"
            name="firstName"
            :label="$t('Firstname')"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm my-1"
            v-show="errors.has('firstName')"
            >{{ errors.first("firstName") }}</span
          >
        </div>
        <div class="vx-col md:w-1/2 w-full mb-2">
          <vs-input
            class="inputx"
            v-model="model.lastName"
            name="lastName"
            :label="$t('Lastname')"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm my-1"
            v-show="errors.has('lastName')"
            >{{ errors.first("lastName") }}</span
          >
        </div>
        <div class="vx-col md:w-1/2 w-full mb-2">
          <vs-input
            class="inputx"
            v-model="model.nickName"
            name="nickName"
            :label="$t('nickName')"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm my-1"
            v-show="errors.has('nickName')"
            >{{ errors.first("nickName") }}</span
          >
        </div>
        <div class="vx-col md:w-1/2 w-full mb-2">
          <vs-input
            class="inputx"
            v-model="model.mobileNumber"
            name="mobileNumber"
            :label="$t('MobileNumber')"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm my-1"
            v-show="errors.has('mobileNumber')"
            >{{ errors.first("mobileNumber") }}</span
          >
        </div>
        <div class="vx-col md:w-1/2 w-full mb-2">
          <vs-input
            class="inputx"
            v-model="model.driverLicenseNumber"
            name="driverLicenseNumber"
            :label="$t('driverLicenseNumber')"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm my-1"
            v-show="errors.has('driverLicenseNumber')"
            >{{ errors.first("driverLicenseNumber") }}</span
          >
        </div>
        <div class="vx-col md:w-1/2 w-full my-2">
          <vs-button
            type="filled"
            class="float-right my-2 md:w-auto w-full"
            @click.prevent="submitForm"
            >{{ $t("Save") }}</vs-button
          >
        </div>
      </form>
    </vs-popup>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
const dict = {
  custom: {
    firstName: {
      required: "لطفا نام را وارد نمایید.",
    },
    lastName: {
      required: "لطفا نام خانوادگی را وارد نمایید.",
    },
    nickName: {
      required: "لطفا نام مستعار را وارد نمایید.",
    },
    mobileNumber: {
      required: "لطفا شماره تلفن همراه را وارد نمایید.",
    },
    driverLicenseNumber: {
      required: "لطفا شماره گواهینامه را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "shipping-Operators-createPopup",
  props: {
    show: { default: false },
  },
  data() {
    return {
      model: {},
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createOperator: "shipping/createOperator",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.createOperator(this.model).then(() => {
            this.model = {};
            this.$validator.reset();
            setTimeout(() => {
              this.$emit("finish");
            }, 3000);
          });
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.model = {
          firstName: "",
          lastName: "",
          nickName: "",
          mobileNumber: "",
          driverLicenseNumber: "",
        };
      }
    },
  },
};
</script>
